export enum LicenciaEstados {
  sin_antecedentes = 1,
  antecedentes_parciales = 2,
  antecedentes_completos = 3,
}

export default LicenciaEstados;